import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import dayjs from 'dayjs'
import 'dayjs/locale/de'

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .on('languageChanged', function (lng) {
    dayjs.locale(lng)
  })
  .init({
    debug: false,
    fallbackLng: 'en',
    // Setting supportedLngs explicitly so components can access it; This gives us a central place to manage available/supported languages.
    supportedLngs: ['en', 'de'],
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    backend: {
      loadPath: (lng, ns) => `/locales/${lng}/${ns}.json?v=${__webpack_hash__}`,
    },
  })

export default i18n
